import VersionText from "./versionText";

export default VersionText;